// Limio docs: https://limio.zendesk.com/hc/en-gb/articles/4402697472017-How-to-Configure-the-Limio-Data-Layer-to-Collect-User-Events-for-Analytics

import {Logger} from "./Logger";
import {trackSelfDescribingEvent} from '@snowplow/browser-tracker';

export function LimioPlugin() {
  let _logger = Logger();
  let _trackerInstance;

  function initDatalayerIntegration(attempt) {
    if (limio && limio.dataLayer) {
      limio.dataLayer.subscribe(cb);
      _logger.debug("Limio Plugin registered a callback");
    } else if (attempt < 100) {
      setTimeout(initDatalayerIntegration, 100 + (attempt * 10), attempt + 1);
    }

    //where the callback function had the following signature
    function cb(limioEvent) {
      /*
      Possible events:

            In the event of a customer adding an Offer to Cart:
            {
              event: "add_to_cart",
              label: "Add offer: xxxxx",
              currency: "USD",
              value: 50.00
            }

            In the event of a customer initialising the Checkout flow:
            {
              event: "begin_checkout",
              label: "Begin Checkout",
              currency: "USD",
              value: 50.00 (total value of checkout at that point)
            }

            In the event of a customer successfully completing an order:
            {
              event: "order",
              order_type: "new" | "renew" | "cancel_subscription" | "add_offer" | "change_offer" | "change_address" | "update_customer_details" | "refund",
            }
       */
      _logger.debug("Received Limio event", limioEvent);
      if (limioEvent && limioEvent.event) {
        const stepId = mapLimioEventType(limioEvent.event);
        if (stepId !== "unknown-step") {
          const wizardEvent = {
            event: {
              schema: "iglu:be.mediafin.subscription/wizard/jsonschema/1-1-0",
              data: {"stepId": stepId, ...limioEvent}
            }
          };
          trackSelfDescribingEvent(wizardEvent);
        }
      }
    }
  }

  function mapLimioEventType(eventType) {
    switch (eventType) {
      case "add_to_cart":
        return "campaign-first-step";
      case "begin_checkout":
        return "personal-data";
      case "order":
        return "payment";
      default:
        return "unknown-step";
    }
  }

  //implementation for methods from Snowplow BrowserPlugin interface
  return {
    activateBrowserPlugin: (tracker) => {
      _trackerInstance = tracker;
      initDatalayerIntegration(0);
      _logger.debug("Limio Plugin activated on sp instance id and namespace ", tracker.id, tracker.namespace);
    },
    logger: (logger) => _logger = logger
  }
}
